<proffeo-ui-card
  density="compact"
  class="min-w-0 max-w-full overflow-x-hidden"
>
  <div class="flex flex-col gap-2">
    <proffeo-task-details-header
      (closeRequested)="closeRequested.emit()"
      (nameEditCancelled)="nameEditCancelled.emit()"
      (nameEditRequested)="nameEditRequested.emit()"
      (taskNameChanged)="taskNameChanged.emit($event)"
      (taskTypeSelected)="taskTypeSelected.emit($event)"
      [isMobile]="true"
      [isNameEditing]="isNameEditing()"
      [maxTaskNameLength]="maxTaskNameLength()"
      [taskActionsMenu]="taskActionsMenu()"
      [taskTypes]="taskTypes()"
      [task]="task()"
    />

    <proffeo-task-details-metadata-panel
      (openTimeReportRequested)="timeReportRequested.emit($event)"
      (timeReportsTabRequested)="timeReportsTabRequested.emit()"
      [layout]="'mobile'"
      [task]="task()"
    />

    <div class="task-details-tabs-surface">
      <nav
        [tabPanel]="taskTabPanel"
        [disablePagination]="true"
        [mat-stretch-tabs]="false"
        mat-tab-nav-bar
        class="task-details-tabs"
      >
        @for (tab of taskTabs; track tab.index) {
          <a
            (click)="onTabClick(tab.index, $event)"
            [active]="currentTabIndex() === tab.index"
            mat-tab-link
          >
            <span class="flex items-center gap-1.5">
              <mat-icon
                [fontIcon]="tab.icon"
                class="icon-md"
              />
              <span class="text-nowrap">{{ tab.labelKey | translate }}</span>
            </span>
          </a>
        }
      </nav>
    </div>

    <mat-tab-nav-panel #taskTabPanel>
      <ng-container *ngTemplateOutlet="tabContent()" />
    </mat-tab-nav-panel>
  </div>
</proffeo-ui-card>

<ng-container *ngTemplateOutlet="subtasksContent()" />
